import { render, staticRenderFns } from "./DpaNotificationsAdDialogue.vue?vue&type=template&id=3e38cdb4&scoped=true&"
import script from "./DpaNotificationsAdDialogue.vue?vue&type=script&lang=ts&"
export * from "./DpaNotificationsAdDialogue.vue?vue&type=script&lang=ts&"
import style0 from "./DpaNotificationsAdDialogue.vue?vue&type=style&index=0&id=3e38cdb4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e38cdb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
